(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("a7EfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $765d763c6697a523$export$2e2bcd8739ae039; });

var $fcWbB = parcelRequire("fcWbB");


const $765d763c6697a523$var$createSnowplowV1Tracker = async (input)=>{
    // We only load the impressions handler if the event is an impression
    const loadImpressionHandler = async ()=>{
        return await (parcelRequire("dtrGp")).then(({ default: load })=>load());
    };
    const loadEcommerceHandler = async ()=>{
        return await (parcelRequire("lJHI1")).then(({ default: load })=>load(input));
    };
    return {
        context: input,
        initialize: $fcWbB.initialize,
        // Load ecommerce handler only if the event is a transaction or if no event is specified
        ecommerce: (input.event === "transaction" || !input.event) && await loadEcommerceHandler(),
        impressions: input.event === "impression" && await loadImpressionHandler(),
        trackSignup: (input)=>{
            const { uuid: uuid, firstName: firstName, lastName: lastName, gender: gender, emailAddress: emailAddress, hashedEmailAddress: hashedEmailAddress, address: address, city: city, state: state, phoneNumber: phoneNumber, advertiser: advertiser, test: test } = input;
            window.tracker("trackSelfDescribingEvent", {
                schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-4",
                data: {
                    uuid: uuid,
                    firstName: firstName,
                    lastName: lastName,
                    gender: gender,
                    emailAddress: emailAddress,
                    hashedEmailAddress: hashedEmailAddress,
                    address: address,
                    city: city,
                    state: state,
                    phoneNumber: phoneNumber,
                    advertiser: advertiser,
                    test: test
                }
            });
        },
        record: (input)=>{
            window.tracker("trackSelfDescribingEvent", {
                schema: "iglu:com.mediajel.events/record/jsonschema/1-0-2",
                data: input
            });
        }
    };
};
var $765d763c6697a523$export$2e2bcd8739ae039 = $765d763c6697a523$var$createSnowplowV1Tracker;

});
parcelRegister("fcWbB", function(module, exports) {

$parcel$export(module.exports, "initialize", function () { return $f1bc8133b7a10e7f$export$2a47f398eeff8b01; });
const $f1bc8133b7a10e7f$export$2a47f398eeff8b01 = ({ appId: appId, collector: collector, event: event, sdkUrl: sdkUrl })=>{
    console.log(`SDK URL: ${sdkUrl}`);
    // Loading tracker with the snowplow tag by fetching our sp.js file
    // Creates a global function called "tracker" which we use to access the Snowplow Tracker
    (function(e, o, n, t, a, c, i) {
        if (!e[a]) {
            e.GlobalSnowplowNamespace = e.GlobalSnowplowNamespace || [];
            e.GlobalSnowplowNamespace.push(a);
            e[a] = function() {
                (e[a].q = e[a].q || []).push(arguments);
            };
            e[a].q = e[a].q || [];
            c = o.createElement(n);
            i = o.getElementsByTagName(n)[0];
            c.async = 1;
            c.src = t;
            i.parentNode.insertBefore(c, i);
        }
    })(window, document, "script", "//dm2q9qfzyjfox.cloudfront.net/sp.js", "tracker");
    // Creates the tracker with the appId and sends events to collector url
    window.tracker("newTracker", `${appId}_v2`, `${collector}`, {
        appId: appId,
        postPath: "/analytics/track",
        discoverRootDomain: true,
        stateStorageStrategy: "cookieAndLocalStorage",
        cookieSameSite: "Lax",
        respectDoNotTrack: false,
        eventMethod: "post"
    });
    // Second tracker for new pipeline collector
    window.tracker("newTracker", appId, "collector-latest.dmp.cnna.io", {
        appId: appId,
        postPath: "/analytics/track",
        discoverRootDomain: true,
        stateStorageStrategy: "cookieAndLocalStorage",
        cookieSameSite: "Lax",
        respectDoNotTrack: false,
        eventMethod: "post"
    });
    window.tracker("enableActivityTracking", 30, 10);
    window.tracker("trackPageView");
    window.tracker("enableFormTracking");
    /**
   * !IMPORTANT: We are disabling this as to not override Link click config for the impression pixel.
   * Enabling this for impressions will cause click tracking to break
   */ if (event !== "impression") window.tracker("enableLinkClickTracking");
};

});

parcelRegister("dtrGp", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("cJt3G")).then(()=>parcelRequire("5AUYO"));

});

parcelRegister("lJHI1", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("41h2r")).then(()=>parcelRequire("bLsGx"));

});


})();
//# sourceMappingURL=tracker.26e14b7d.js.map
